import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useToast } from "../components/Toast";

const LoginSuccess = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const backend_url = process.env.REACT_APP_BACKEND_URL;
  const { showToast } = useToast();

  useEffect(() => {
    const token = localStorage.getItem("authToken");
    if (token) {
      navigate("/dashboard");
      return;
    }
    const code = searchParams.get('code');
    if (!code) {
      console.error('Missing Google code');
      navigate('/');
      return;
    }
    // Exchange code for JWT
    const exchangeToken = async () => {
      try {
        const res = await fetch(`${backend_url}/api/google-auth/exchange?code=${code}`);
        const data = await res.json();

        if (data.ok) {
          localStorage.setItem('authToken', data.token);
          navigate('/dashboard');
          showToast(`Login Successfully`, "Success");
        } else {
          showToast(`${data.message}`, "Fail");
          navigate('/');
        }
      } catch (err) {
        console.error('Login exchange failed:', err);
        showToast(`'Login failed: ' + ${err.message}`, "Fail");
        navigate('/');
      }
    };

    exchangeToken();
  }, [navigate, searchParams, backend_url]);

  return (
    <div style={{
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "80vh",
      fontSize: "18px",
      color: "#333"
    }}>
      <div className="spinner"></div>
      <p style={{ marginTop: "20px", color: "#555" }}>
        Authenticating with Google…
      </p>
    </div>
  );

};

export default LoginSuccess;


// import { useEffect } from 'react';
// import { useNavigate, useLocation } from 'react-router-dom';

// const LoginSuccess = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   useEffect(() => {
//     const params = new URLSearchParams(location.search);
//     const token = params.get('token');

//     if (token) {
//       localStorage.setItem('authToken', token);
//       navigate('/dashboard');
//     } else {
//       navigate('/login');
//     }
//   }, [location, navigate]);

//   return <p>Logging in...</p>;
// };

// export default LoginSuccess;
